var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlugins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mask",
    d: "M0,0H60V60H0Z",
    transform: "translate(573 418)",
    fill: "#c7cdd1",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8400",
    "data-name": "Rectangle 8400",
    width: 39.285,
    height: 39.285,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6550",
    "data-name": "Mask Group 6550",
    transform: "translate(-573 -418)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35261",
    "data-name": "Group 35261",
    transform: "translate(581.102 426.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35272",
    "data-name": "Group 35272",
    transform: "translate(0.541 0.542)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8399",
    "data-name": "Rectangle 8399",
    width: 31.238,
    height: 31.37,
    transform: "translate(8.047 7.915)",
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35271",
    "data-name": "Group 35271",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35270",
    "data-name": "Group 35270",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36048",
    "data-name": "Path 36048",
    d: "M29.795,15.893H27.457A4.566,4.566,0,0,1,22.9,11.341V4.553A4.566,4.566,0,0,1,27.457,0h2.338a4.566,4.566,0,0,1,4.553,4.553v6.788a4.566,4.566,0,0,1-4.553,4.553",
    transform: "translate(-4.959 0)",
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36049",
    "data-name": "Path 36049",
    d: "M15.893,29.265V31.6a4.566,4.566,0,0,1-4.553,4.553H4.553A4.566,4.566,0,0,1,0,31.6V29.265a4.566,4.566,0,0,1,4.553-4.553h6.788a4.566,4.566,0,0,1,4.553,4.553",
    transform: "translate(0 -5.351)",
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36050",
    "data-name": "Path 36050",
    d: "M28.018,16.894a9.448,9.448,0,1,1-9.449,9.449,9.449,9.449,0,0,1,9.449-9.449",
    transform: "translate(-4.021 -3.658)",
    fill: "#0e2b72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36051",
    "data-name": "Path 36051",
    d: "M33.594,26.152c.186-1.238-.756-1.9-2.046-2.347l.418-1.677-1.021-.254-.407,1.633c-.268-.067-.544-.13-.818-.192l.411-1.644-1.021-.255-.418,1.676c-.222-.05-.44-.1-.652-.153v-.005l-1.408-.351-.272,1.09s.756.174.741.185a.544.544,0,0,1,.476.594l-.476,1.91a.83.83,0,0,1,.106.034l-.107-.027-.666,2.676a.372.372,0,0,1-.465.244h0c.009.015-.742-.186-.742-.186l-.507,1.169,1.329.331c.247.062.489.127.727.189l-.422,1.7,1.019.255.419-1.678c.278.076.548.146.813.212l-.416,1.67,1.021.255.422-1.693c1.74.331,3.049.2,3.6-1.377a1.791,1.791,0,0,0-.938-2.476,1.627,1.627,0,0,0,1.3-1.5Zm-2.332,3.27c-.316,1.268-2.449.583-3.142.411l.561-2.246c.692.172,2.911.514,2.581,1.836m.316-3.288c-.288,1.153-2.064.567-2.64.425l.508-2.039c.576.142,2.432.411,2.133,1.613Z",
    transform: "translate(-5.352 -4.637)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugins);
export default __webpack_public_path__ + "static/media/plugins.bf7115fe5c61731204292dc959625e3b.svg";
export { ForwardRef as ReactComponent };